// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class ProductVisitObserver extends Component {
  /**
   * @inheritDoc
   */
  bind(element: HTMLElement) {
    super.bind(element);

    if (!this.el.dataset.productId) {
      throw new Error('A product id is required');
    }

    const isSuccess: boolean = this.addToSession();
    if (!isSuccess) {
      this.addListener(Notifications.COOKIES_CHANGED, ({ value }: { value: string }) => {
        if (value === '1') {
          this.addToSession();
        }
      });
    }
  }

  /**
   * Add the product to the session
   */
  addToSession(): boolean {
    return window.store.sessionManager.addRecentlyVisitedProduct(this.el.dataset.productId);
  }
}
